import { Component, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Subject, takeUntil } from 'rxjs';

import { ICreateKeywordsDialogData } from 'editing-tool/src/app/shared/components/keyword/create-keywords-dialog/create-keywords-dialog-data';
import { ValidationService } from 'sc-common';

@Component({
    templateUrl: './create-keywords-dialog.component.html',
    standalone: false
})
export class CreateKeywordsDialogComponent implements OnDestroy {

    public requestInProcess: boolean;

    public readonly form: UntypedFormGroup;

    private readonly _dialogData: ICreateKeywordsDialogData;

    private readonly _destroy$ = new Subject<void>();

    constructor(
        dialogConfig: DynamicDialogConfig,
        private readonly _formBuilder: UntypedFormBuilder,
        private readonly _dialogRef: DynamicDialogRef) {

        this._dialogData = dialogConfig.data as ICreateKeywordsDialogData;
        this.form = this._buildForm();
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public create(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.requestInProcess = true;

        this._dialogData.createKeywords(this.form.value)
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => this._dialogRef.close(true));
    }

    private _buildForm(): UntypedFormGroup {
        return this._formBuilder.group({
            keyword: [null, [Validators.required, ValidationService.alphaNumSymbolValidator]],
            splitAndCapitalize: [true]
        });
    }
}
